import { render, staticRenderFns } from "./ActivityWsVideo.vue?vue&type=template&id=65de7a38&scoped=true"
import script from "./ActivityWsVideo.vue?vue&type=script&lang=ts"
export * from "./ActivityWsVideo.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsVideo.vue?vue&type=style&index=0&id=65de7a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de7a38",
  null
  
)

export default component.exports